<template>
  <section class="split-text">
    <div class="section-wrap">
      <Header dark :trigger="trigger"/>
    </div>
    <div class="container container--flex">
      <h1 class="split-text__head">mikkel aabjerg has experience working with digital design for various large corporatons.</h1>
      <p class="split-text__text">working with the likes of SAS, yousee, novo nordic etc. has granted mikkel great insight into how to make projects within an identity and how to create a design guide around it - helping corporations gain a coherent digital identity</p>
    </div>
  </section>
</template>

<script>
import './style.scss';
import Header from '@/components/Header/Header';

export default {
  name: 'Mikkel',
  data() {
    return {
    };
  },
  methods: {
  },
  components: {
    Header,
  },
  props: {
    trigger: Function,
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Mikkel/Mikkel.vue